var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewAcademyIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13.865,
    viewBox: "0 0 13 13.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shield-alt",
    "data-name": "Icon awesome-shield-alt",
    d: "M13.326,2.268,8.126.1a1.3,1.3,0,0,0-1,0l-5.2,2.167a1.3,1.3,0,0,0-.8,1.2c0,5.376,3.1,9.092,6,10.3a1.3,1.3,0,0,0,1,0c2.321-.967,6-4.306,6-10.3A1.3,1.3,0,0,0,13.326,2.268Zm-5.7,9.82,0-10.319,4.764,1.985A9.281,9.281,0,0,1,7.628,12.088Z",
    transform: "translate(-1.125 -0.002)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAcademyIco);
export default __webpack_public_path__ + "static/media/new-academy-ico.c8151061.svg";
export { ForwardRef as ReactComponent };